/* eslint-disable react/no-children-prop */
import {
  Box,
  Button,
  Image,
  Input,
  InputGroup,
  InputLeftAddon,
  Spacer,
  Spinner,
  Stack,
  Text,
  useToast,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import logo from '../../assets/1.png';
import {
  MdEmail,
} from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import {
  sendPasswordResetEmail,
} from 'firebase/auth';
import { auth } from '../../Config/firebase';
import useUserStore from '../../Hooks/Zustand/Store';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const globalState = useUserStore();

  if (globalState?.uid) {
    navigate('/');
  }

  const toast = useToast();

  const handleUpdatePassword = () => {
    setLoading(true);
    if (email === null || email === '') {
      toast({
        title: 'Error',
        description: 'Input email',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } else {
      sendPasswordResetEmail(auth, email)
        .then(() => {
          toast({
            title: 'Success',
            description:
              'Reset password request has been sent, kindly check your email!',
            status: 'success',
            duration: 3000,
            isClosable: true,
          });
          setLoading(false);
          navigate('/login');
        })
        .catch((error) => {
          toast({
            title: error.code,
            description: error.message,
            status: 'error',
            duration: 9000,
            isClosable: true,
          });
          setLoading(false);
        });
    }
  };

  const height = window.innerHeight;

  return (
    <>
      <Stack
        spacing={10}
        pt={20}
        minH={height}
        bg="url(https://buildfire.com/wp-content/themes/buildfire/assets/images/gsf-hero-sm.jpg) no-repeat center center fixed"
        bgSize="cover"
        alignItems={'center'}
        justifyContent="center"
      >
        <Stack>
          <Stack alignItems={'center'} justifyContent="center">
            <Stack
              justifyContent="center"
              alignItems="center"
              spacing={5}
              pb={10}
              bgColor="blackAlpha.500"
              p={10}
              borderRadius="xl"
            >
              <Box>
                <Image
                  w="200px"
                  borderRadius={20}
                  src={logo}
                  alt="Alternate Text"
                />
              </Box>
              <Spacer />
              <Stack alignItems="center">
                <InputGroup
                  w={{
                    base: '100%',
                    md: '285',
                  }}
                >
                  <InputLeftAddon
                    shadow={'md'}
                    children={<MdEmail name="email" size={24} color="black" />}
                  />
                  <Input
                    w={{
                      base: '100%',
                      md: '100%',
                    }}
                    placeholder="email"
                    fontSize={'md'}
                    shadow={3}
                    bgColor={'white'}
                    color={'black'}
                    onChange={
                      (e) => setEmail(e.target.value)
                      //   setDataLogin({ ...dataLogin, email: e.target.value })
                    }
                  />
                </InputGroup>
              </Stack>

              <Stack pt={5}>
                {loading ? (
                  <Spinner size={'sm'} />
                ) : (
                  <Button
                    alignItems={'center'}
                    justifyContent="center"
                    size={'sm'}
                    bgColor={'white'}
                    onClick={() => handleUpdatePassword()}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleUpdatePassword();
                      }
                    }}
                  >
                    <Text color={'black'} fontSize="xs" fontWeight="bold">
                      SEND RESET PASSWORD
                    </Text>
                  </Button>
                )}
              </Stack>

              <Spacer />

            </Stack>
          </Stack>
          <Spacer />
        </Stack>
      </Stack>
    </>
  );
}

export default ForgotPassword;
